export type Credentials = {
  pos_terminal: boolean;
  create_and_edit_own_orders: boolean;
  view_orders_of_other_employees: boolean;
  edit_orders_of_other_employees: boolean;
  change_service_discount_percentage: boolean;
  select_client_in_order: boolean;
  delete_items_in_order: boolean;
  open_close_pos_shifts: boolean;

  kitchen_screen: boolean;
  change_order_statuses: boolean;
  make_semifinished_products: boolean;

  booking: boolean;

  dashboard: boolean;

  order_archive: boolean;
  view_archive_of_other_employees: boolean;
  to_cancel_payment: boolean;
  print_bill: boolean;

  pos_shift_archive: boolean;

  visitor_reviews: boolean;

  reports: boolean;

  promotions: boolean;
  create_and_edit_promotions: boolean;

  clients: boolean;
  add_and_edit_clients: boolean;
  set_personal_discount: boolean;

  stores: boolean;
  edit_stores: boolean;
  conduct_inventory: boolean;
  create_supplies: boolean;
  accept_supplies: boolean;
  edit_supplies: boolean;

  journal: boolean;
  view_work_shifts_of_other_employees: boolean;
  edit_own_work_shifts: boolean;
  edit_work_shifts_of_other_employees: boolean;

  workers: boolean;

  wallets: boolean;
  view_hidden_wallets: boolean;
  perform_operations_with_wallets: boolean;
  cancel_operations_with_wallets: boolean;
  edit_wallets: boolean;

  salary: boolean;
  view_other_employees_salary: boolean;
  perform_salary_payments: boolean;

  menu_and_product_settings: boolean;
  restaurant_settings: boolean;
  access_without_shift: boolean;
  allow_create_shift_on_login: boolean;

  legal_entities: boolean;
  self_order_points: boolean;
};

export type CredentialKey = keyof Credentials;

export type CredentialsMap = {
  [key in CredentialKey]?:
    | null
    | {
        [key in CredentialKey]?:
          | null
          | {
              [key in CredentialKey]?: null;
            };
      };
};

export const credentialsMap: CredentialsMap = {
  pos_terminal: {
    create_and_edit_own_orders: null,
    change_service_discount_percentage: null,
    select_client_in_order: null,
    delete_items_in_order: null,
    open_close_pos_shifts: null,
    view_orders_of_other_employees: {
      edit_orders_of_other_employees: null,
    },
  },
  kitchen_screen: {
    change_order_statuses: null,
    make_semifinished_products: null,
  },
  booking: null,
  reports: null,
  dashboard: {},
  order_archive: {
    view_archive_of_other_employees: null,
    print_bill: null,
    to_cancel_payment: null,
  },
  pos_shift_archive: null,
  visitor_reviews: null,
  stores: {
    conduct_inventory: null,
    edit_stores: null,
    create_supplies: null,
    accept_supplies: null,
    edit_supplies: null,
  },
  journal: {
    view_work_shifts_of_other_employees: null,
    edit_own_work_shifts: null,
    edit_work_shifts_of_other_employees: null,
  },
  workers: null,
  wallets: {
    view_hidden_wallets: null,
    perform_operations_with_wallets: null,
    cancel_operations_with_wallets: null,
    edit_wallets: null,
  },
  salary: {
    view_other_employees_salary: null,
    perform_salary_payments: null,
  },
  promotions: {
    create_and_edit_promotions: null,
  },
  clients: {
    add_and_edit_clients: null,
    set_personal_discount: null,
  },
  menu_and_product_settings: null,
  restaurant_settings: null,
  legal_entities: null,

  access_without_shift: null,
  allow_create_shift_on_login: null,
  self_order_points: null,
};

export const ownerCredentials: Credentials = {
  pos_terminal: true,
  create_and_edit_own_orders: true,
  change_service_discount_percentage: true,
  select_client_in_order: true,
  view_orders_of_other_employees: true,
  edit_orders_of_other_employees: true,
  delete_items_in_order: true,
  open_close_pos_shifts: true,

  kitchen_screen: true,
  change_order_statuses: true,
  make_semifinished_products: true,

  booking: true,

  dashboard: true,

  order_archive: true,
  view_archive_of_other_employees: true,
  print_bill: true,
  to_cancel_payment: true,

  pos_shift_archive: true,

  visitor_reviews: true,

  reports: true,

  stores: true,
  edit_stores: true,
  conduct_inventory: true,
  create_supplies: true,
  accept_supplies: true,
  edit_supplies: true,

  journal: true,
  view_work_shifts_of_other_employees: true,
  edit_own_work_shifts: true,
  edit_work_shifts_of_other_employees: true,

  workers: true,

  wallets: true,
  view_hidden_wallets: true,
  perform_operations_with_wallets: true,
  cancel_operations_with_wallets: true,
  edit_wallets: true,

  salary: true,
  view_other_employees_salary: true,
  perform_salary_payments: true,

  promotions: true,
  create_and_edit_promotions: true,

  clients: true,
  add_and_edit_clients: true,
  set_personal_discount: true,

  menu_and_product_settings: true,
  restaurant_settings: true,
  legal_entities: true,

  access_without_shift: true,
  allow_create_shift_on_login: true,
  self_order_points: true,
};

export const emptyCredentials: Credentials = {
  pos_terminal: false,
  create_and_edit_own_orders: false,
  change_service_discount_percentage: false,
  select_client_in_order: false,
  view_orders_of_other_employees: false,
  edit_orders_of_other_employees: false,
  delete_items_in_order: true,
  open_close_pos_shifts: false,

  kitchen_screen: false,
  change_order_statuses: false,
  make_semifinished_products: false,

  booking: false,

  dashboard: false,

  reports: false,

  order_archive: false,
  view_archive_of_other_employees: false,
  print_bill: false,
  to_cancel_payment: false,

  pos_shift_archive: false,

  visitor_reviews: false,

  stores: false,
  edit_stores: false,
  conduct_inventory: false,
  create_supplies: false,
  accept_supplies: false,
  edit_supplies: false,

  journal: false,
  view_work_shifts_of_other_employees: false,
  edit_own_work_shifts: false,
  edit_work_shifts_of_other_employees: false,

  workers: false,

  wallets: false,
  view_hidden_wallets: false,
  perform_operations_with_wallets: false,
  cancel_operations_with_wallets: false,
  edit_wallets: false,

  salary: false,
  view_other_employees_salary: false,
  perform_salary_payments: false,

  promotions: false,
  create_and_edit_promotions: false,

  clients: false,
  add_and_edit_clients: false,
  set_personal_discount: false,

  menu_and_product_settings: false,
  restaurant_settings: false,
  legal_entities: false,

  access_without_shift: false,
  allow_create_shift_on_login: false,
  self_order_points: false,
};

export const adminCredentials: Credentials = {
  ...ownerCredentials,
  view_hidden_wallets: false,
  self_order_points: false,
};

export const waiterCredentials: Credentials = {
  ...adminCredentials,
  change_service_discount_percentage: false,
  edit_orders_of_other_employees: false,
  dashboard: false,
  stores: false,
  workers: false,
  wallets: false,
  salary: false,
  menu_and_product_settings: false,
  restaurant_settings: false,
  change_order_statuses: false,
  make_semifinished_products: false,
  view_archive_of_other_employees: false,
  print_bill: false,
  to_cancel_payment: false,
  visitor_reviews: false,
  edit_supplies: false,
  edit_own_work_shifts: false,
  edit_work_shifts_of_other_employees: false,
  perform_operations_with_wallets: false,
  cancel_operations_with_wallets: false,
  edit_wallets: false,
  view_other_employees_salary: false,
  perform_salary_payments: false,
  legal_entities: false,
  access_without_shift: false,
  create_and_edit_promotions: false,
  set_personal_discount: false,
};

export const chefCredentials: Credentials = {
  ...waiterCredentials,
  booking: false,
  promotions: false,
  create_and_edit_own_orders: false,
  edit_orders_of_other_employees: false,
  open_close_pos_shifts: false,
  pos_shift_archive: false,
  change_order_statuses: true,
  make_semifinished_products: true,
  stores: true,
  edit_stores: false,
  clients: false,
  add_and_edit_clients: false,
};
